import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LyricsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lyrics"}/>
}
